import * as kontentAIComponentMapping from '../kontent_ai_mapping';

export type KontentAiComponentMapping = typeof kontentAIComponentMapping;
export const KONTENT = 'KONTENT';
export const CONTENTFUL = 'CONTENTFUL';

export const enum SupportedDataSources {
  KontentAi = 'KONTENT',
  Contentful = 'CONTENTFUL',
  EmsPpApi = 'EMSPP_API'
}

export type DataMapper = {
  KONTENT: KontentAiComponentMapping;
  // CONTENTFUL: ContentfulComponentMapping;
  // EMSPP_API: EmsPpApiComponentMapping;
};
